import { Link } from "react-router-dom";

const ALT = "SparkRead logo — open book with spark icon";

/**
 * Official SparkRead logo (PNG). Never recreated, recolored, or cropped.
 * Variants:
 *   - "header"  → compact, fits inside the sticky nav
 *   - "footer"  → large mark for the footer column
 *   - "auth"    → centered mark for login/register/onboarding cards
 *   - "raw"     → just the <img>, no Link wrapper
 *
 * Pass `as="link"` (default) to wrap in a Link to "/", or `as="span"` for static use.
 */
export default function Logo({ variant = "header", as = "link", className = "" }) {
  const sizes = {
    header: "h-12 w-12 sm:h-14 sm:w-14 lg:h-16 lg:w-16",
    footer: "h-32 w-32 sm:h-40 sm:w-40",
    auth: "h-20 w-20",
    raw: "h-10 w-10",
  };
  const img = (
    <img
      src="/sparkread-logo.png"
      alt={ALT}
      width={256}
      height={256}
      loading="eager"
      decoding="async"
      className={`${sizes[variant] || sizes.header} object-contain select-none ${className}`}
      data-testid={`sparkread-logo-${variant}`}
      draggable="false"
    />
  );
  if (as === "span") return img;
  return (
    <Link to="/" aria-label="SparkRead — homepage" className="inline-flex items-center">
      {img}
    </Link>
  );
}
